export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/earth-base.63599056-a63310.svg";